export default __webpack_public_path__ + "static/media/portfolio-126.ecb1b8c2.jpg";